import IconButton from '@mui/material/IconButton';
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import IosShareIcon from '@mui/icons-material/IosShare';
import { BackButton, BackButtonDark, HeaderFixed } from '@/components';

import styles from './FlyerDetailsHeader.styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '@/config/constants';
import { useNavigateWithTracking } from '@/hooks';
import { EventDetails, TrackingEvents, TrackingStage } from '@/config/tracking';

interface FlyerDetailsHeaderProps {
  onShare: () => void;
  goToPreviousPage: () => void;
  onClickFavorite: () => void;
  isFavorite: boolean;
  flyerType: string;
}

export const FlyerDetailsHeader: React.FC<FlyerDetailsHeaderProps> = ({
  onShare,
  goToPreviousPage,
  onClickFavorite,
  isFavorite,
  flyerType,
}) => {
  const { search } = useLocation();
  const navigateWithTracking = useNavigateWithTracking();
  const searchParams = new URLSearchParams(search);
  const originParam = searchParams.get('origin');
  const isFromEmail = originParam && originParam === 'email';

  const onBackButtonClick = () => {
    if (isFromEmail) {
      navigateWithTracking(APP_ROUTES.jar, {
        event_from: TrackingEvents.viewFlyerDetails,
        event_detail_from: EventDetails.viewFlyerDetails(flyerType),
        stage_from: TrackingStage.consideration,
      });
    } else {
      goToPreviousPage();
    }
  };
  return (
    <HeaderFixed>
      <div className={styles.container} data-testid="flyerDetailsHeader">
        <nav className={styles.content} aria-label="Flyer details header">
          <div className={styles.backButton}>
            {isFromEmail ? (
              <BackButtonDark
                trackId="flyer_details"
                onClick={onBackButtonClick}
                text="All Flyers"
                size={35}
              />
            ) : (
              <BackButton trackId="flyer_details" size={35} />
            )}
          </div>
          <IconButton
            onClick={onClickFavorite}
            aria-label="Mark flyer as favorite"
            data-testid="favoriteButton"
            aria-pressed={isFavorite}
          >
            {isFavorite ? (
              <StarRoundedIcon sx={{ fontSize: 45 }} className={styles.favoriteIconSelected} />
            ) : (
              <StarOutlineRoundedIcon sx={{ fontSize: 45 }} />
            )}
          </IconButton>
          <div className={styles.shareButton}>
            <IconButton
              onClick={onShare}
              aria-label="Share flyer button"
              data-testid="shareFlyerButton"
            >
              <IosShareIcon sx={{ fontSize: 30 }}/>
            </IconButton>
          </div>
        </nav>
      </div>
    </HeaderFixed>
  );
};
